import script from "./VendorDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./VendorDetail.vue?vue&type=script&setup=true&lang=js"

import "./VendorDetail.vue?vue&type=style&index=0&id=216d8b96&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-216d8b96"]])

export default __exports__